module.exports = __webpack_public_path__ + "static/domestic_mental_obj03_m@2x-66e129ae4737115c1552bf6d7fe7b22d.jpg";